export const getApiBase = () => {
  const base = import.meta.env.VITE_API_URL || 'http://localhost:8000';
  return base.replace(/\/$/, '');
};
